/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_4_1Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_4_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_4_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop builds for macOS, Windows and Linux; browser build available.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_4_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_4_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提供 macOS、Windows、Linux 桌面版本及浏览器版本。`)
};

/**
* | output |
* | --- |
* | "Desktop builds for macOS, Windows and Linux; browser build available." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_4_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_4_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_4_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_4_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_4_1(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_4_1(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_4_1 as "gc.search_guides.gridcraft_vs_excel.sections.0.table.rows.4.1" }